import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Shield, FileText, HeartPulse } from 'lucide-react';
export function TermsOfService() {
  const {
    t
  } = useLanguage();
  const [activeSection, setActiveSection] = useState<string | null>('cancellation');
  const sections = [{
    id: 'cancellation',
    title: t.terms.cancellation,
    content: t.terms.cancellationText,
    icon: FileText
  }, {
    id: 'privacy',
    title: t.terms.privacy,
    content: t.terms.privacyText,
    icon: Shield
  }, {
    id: 'health',
    title: t.terms.health,
    content: t.terms.healthText,
    icon: HeartPulse
  }];
  return <section id="terms" className="py-24 bg-white" data-id="element-188">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-189">
        <div className="text-center mb-12" data-id="element-190">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-[#3D3D3D] mb-4" data-id="element-191">
            {t.terms.title}
          </h2>
          <p className="text-gray-600" data-id="element-192">{t.terms.intro}</p>
        </div>

        <div className="space-y-4" data-id="element-193">
          {sections.map(section => <div key={section.id} className="border border-gray-100 rounded-2xl overflow-hidden bg-[#FAF7F5]" data-id="element-194">
              <button onClick={() => setActiveSection(activeSection === section.id ? null : section.id)} className="w-full flex items-center justify-between p-6 text-left hover:bg-[#F5F0EB] transition-colors" data-id="element-195">
                <div className="flex items-center gap-4" data-id="element-196">
                  <div className={`p-2 rounded-full ${activeSection === section.id ? 'bg-[#C9A96E] text-white' : 'bg-white text-[#8B7E74]'}`} data-id="element-197">
                    <section.icon size={20} data-id="element-198" />
                  </div>
                  <span className="font-medium text-lg text-[#3D3D3D]" data-id="element-199">
                    {section.title}
                  </span>
                </div>
                <ChevronDown className={`text-gray-400 transition-transform duration-300 ${activeSection === section.id ? 'rotate-180' : ''}`} data-id="element-200" />
              </button>

              <AnimatePresence data-id="element-201">
                {activeSection === section.id && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-202">
                    <div className="px-6 pb-6 pt-2 text-gray-600 leading-relaxed border-t border-gray-100/50" data-id="element-203">
                      {section.content}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}